webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(7);
	var app_component_1 = __webpack_require__(280);
	var router_deprecated_1 = __webpack_require__(281);
	var http_1 = __webpack_require__(316);
	__webpack_require__(364);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.bootstrap(app_component_1.AppComponent, [router_deprecated_1.ROUTER_PROVIDERS, http_1.HTTP_PROVIDERS]);


/***/ },

/***/ 280:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var router_deprecated_1 = __webpack_require__(281);
	var dashboard_component_1 = __webpack_require__(313);
	__webpack_require__(359);
	// var componentHandler = require('exports?componentHandler&MaterialRipple!material-design-lite/material.js');
	var AppComponent = (function () {
	    function AppComponent(_router) {
	        this._router = _router;
	        // ngAfterViewInit() {
	        //     componentHandler.upgradeDom();
	        // }
	        this.appTitle = "Github Bucket";
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        if (sessionStorage.getItem('login') == 'true') {
	            this.isSessionSet = true;
	            this.appTitle = "Hello, " + sessionStorage.getItem('username') + "";
	            this.ButtonText = "Go To My Dashboard";
	        }
	        else {
	            this.isSessionSet = false;
	            this.ButtonText = "Connect With GitHub";
	        }
	    };
	    //triggerd after user clicks button
	    AppComponent.prototype.goToDashboard = function () {
	        this.isDashboard = true;
	        this._router.navigate(['Dashboard']);
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: __webpack_require__(363),
	            encapsulation: core_1.ViewEncapsulation.None,
	            directives: [router_deprecated_1.ROUTER_DIRECTIVES, dashboard_component_1.DashboardComponent],
	            providers: []
	        }),
	        router_deprecated_1.RouteConfig([
	            { path: '/dashboard/...', name: 'Dashboard', component: dashboard_component_1.DashboardComponent }
	        ]), 
	        __metadata('design:paramtypes', [router_deprecated_1.Router])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;
	//# sourceMappingURL=app.component.js.map

/***/ },

/***/ 313:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var router_deprecated_1 = __webpack_require__(281);
	var news_feed_component_1 = __webpack_require__(314);
	var favourite_component_1 = __webpack_require__(340);
	var top_trending_component_1 = __webpack_require__(343);
	var latest_component_1 = __webpack_require__(347);
	var credit_component_1 = __webpack_require__(350);
	var profile_component_1 = __webpack_require__(352);
	var popular_component_1 = __webpack_require__(355);
	var DashboardComponent = (function () {
	    function DashboardComponent(_router) {
	        this._router = _router;
	    }
	    DashboardComponent.prototype.ngAfterViewInit = function () {
	        componentHandler.upgradeDom();
	    };
	    DashboardComponent.prototype.goToPopular = function () {
	        this._router.navigate(['Popular']);
	    };
	    DashboardComponent.prototype.goToCredits = function () {
	        this._router.navigate(['Credit']);
	    };
	    DashboardComponent.prototype.goToProfile = function () {
	        this._router.navigate(['Profile']);
	    };
	    DashboardComponent.prototype.goToFavourite = function () {
	        this._router.navigate(['Favourite']);
	    };
	    DashboardComponent.prototype.goToNewsFeed = function () {
	        this._router.navigate(['NewsFeed']);
	    };
	    DashboardComponent.prototype.goToTrending = function () {
	        this._router.navigate(['TopTrending']);
	    };
	    DashboardComponent.prototype.goToLatest = function () {
	        this._router.navigate(['Latest']);
	    };
	    //logout user
	    DashboardComponent.prototype.logout = function () {
	        sessionStorage.setItem('username', '');
	        sessionStorage.setItem('login', 'false');
	        window.location.assign("/");
	    };
	    DashboardComponent = __decorate([
	        core_1.Component({
	            selector: 'menu-bar',
	            template: __webpack_require__(358),
	            encapsulation: core_1.ViewEncapsulation.None,
	            directives: [router_deprecated_1.RouterOutlet, popular_component_1.PopularComponent, profile_component_1.ProfileComponent, favourite_component_1.FavouriteComponent, news_feed_component_1.NewsFeedComponent, top_trending_component_1.TopTrendingComponent, credit_component_1.CreditComponent]
	        }),
	        router_deprecated_1.RouteConfig([
	            { path: '/', name: 'NewsFeed', component: news_feed_component_1.NewsFeedComponent, useAsDefault: true },
	            { path: '/favourite', name: 'Favourite', component: favourite_component_1.FavouriteComponent },
	            { path: '/top-trending', name: 'TopTrending', component: top_trending_component_1.TopTrendingComponent },
	            { path: '/latest-issues', name: 'Latest', component: latest_component_1.LatestComponent },
	            { path: '/credits', name: 'Credit', component: credit_component_1.CreditComponent },
	            { path: '/profile', name: 'Profile', component: profile_component_1.ProfileComponent },
	            { path: '/most-popular', name: 'Popular', component: popular_component_1.PopularComponent },
	        ]), 
	        __metadata('design:paramtypes', [router_deprecated_1.Router])
	    ], DashboardComponent);
	    return DashboardComponent;
	}());
	exports.DashboardComponent = DashboardComponent;
	//# sourceMappingURL=dashboard.component.js.map

/***/ },

/***/ 314:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var news_feed_service_1 = __webpack_require__(315);
	var user_data_service_1 = __webpack_require__(337);
	var NewsFeed_1 = __webpack_require__(338);
	var NewsFeedComponent = (function () {
	    function NewsFeedComponent(newsFeedService, userDataService) {
	        this.newsFeedService = newsFeedService;
	        this.userDataService = userDataService;
	        this.hasDumped = false;
	    }
	    NewsFeedComponent.prototype.ngOnInit = function () {
	        var username = sessionStorage.getItem('username');
	        var link = "https://api.github.com/users/" + username + "/repos"; //github api
	        this.getDump(link);
	        this.getNewsDump(this.uniqueLang);
	    };
	    NewsFeedComponent.prototype.ngDoCheck = function () {
	        if (this.responseDump && !this.hasDumped && this.newsDump) {
	            var data = this.responseDump;
	            var lang = this.userDataService.getLanguageArray(data);
	            var maxUsedLang = this.getMaxUsed(lang);
	            sessionStorage.setItem('maxLang', maxUsedLang);
	            this.uniqueLang = this.userDataService.getUniqueLanguages(lang);
	            this.hasDumped = true;
	            var box = this.newsDump;
	            this.newsFeed = this.getFilteredNews(box.items);
	        }
	    };
	    //get filtered news
	    NewsFeedComponent.prototype.getFilteredNews = function (data) {
	        var resArray = [];
	        for (var i = 0; i < data.length; i++) {
	            var box = data[i];
	            var myInfo = new NewsFeed_1.NewsFeed();
	            myInfo.name = box.full_name;
	            myInfo.html_url = box.html_url;
	            myInfo.language = box.language;
	            myInfo.description = box.description;
	            myInfo.stars = box.stargazers_count;
	            myInfo.forks = box.forks;
	            myInfo.watchers = box.watchers;
	            resArray.push(myInfo);
	        }
	        return resArray;
	    };
	    //get news feed dump
	    NewsFeedComponent.prototype.getNewsDump = function (langArr) {
	        var _this = this;
	        return this.newsFeedService.getNewsFeed(langArr)
	            .subscribe(function (response) { return _this.newsDump = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    //get all user data
	    NewsFeedComponent.prototype.getDump = function (link) {
	        var _this = this;
	        return this.newsFeedService.getDumpArray(link)
	            .subscribe(function (response) { return _this.responseDump = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    //take to github repo
	    NewsFeedComponent.prototype.goToGithub = function (data) {
	        window.location.assign(data);
	    };
	    NewsFeedComponent.prototype.getMaxUsed = function (langArr) {
	        var maxLang = langArr[0];
	        var maxCount = 0;
	        langArr.map(function (currentValue, index, array) {
	            var check = currentValue;
	            var count = 0;
	            for (var i = 0; i < langArr.length; i++) {
	                if (check == langArr[i]) {
	                    count++;
	                }
	            }
	            if (count > maxCount) {
	                maxCount = count;
	                maxLang = check;
	            }
	        });
	        return maxLang;
	    };
	    NewsFeedComponent = __decorate([
	        core_1.Component({
	            selector: 'news-feed',
	            template: __webpack_require__(339),
	            providers: [news_feed_service_1.NewsFeedService, user_data_service_1.UserDataService]
	        }), 
	        __metadata('design:paramtypes', [news_feed_service_1.NewsFeedService, user_data_service_1.UserDataService])
	    ], NewsFeedComponent);
	    return NewsFeedComponent;
	}());
	exports.NewsFeedComponent = NewsFeedComponent;
	//# sourceMappingURL=news-feed.component.js.map

/***/ },

/***/ 315:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var http_1 = __webpack_require__(316);
	var Observable_1 = __webpack_require__(41);
	var NewsFeedService = (function () {
	    function NewsFeedService(http) {
	        this.http = http;
	        this.languageArray = [];
	        this.filterNews = [];
	    }
	    //get all user repo data
	    NewsFeedService.prototype.getDumpArray = function (link) {
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    //news feed data dump
	    NewsFeedService.prototype.getNewsFeed = function (UserLanguages) {
	        var dateObj = new Date();
	        var month = dateObj.getUTCMonth() + 1; //months from 1-12
	        var day = dateObj.getUTCDate();
	        var year = dateObj.getUTCFullYear();
	        var pastDate;
	        var languages = "";
	        if (day <= 7) {
	            day = 30 + (day - 7);
	            month--;
	        }
	        else {
	            day = day - 7;
	        }
	        if (day < 10 && month < 10) {
	            pastDate = year + "-0" + month + "-0" + day;
	        }
	        else {
	            if (day < 10) {
	                pastDate = year + "-" + month + "-0" + day;
	            }
	            if (month < 10) {
	                pastDate = year + "-0" + month + "-" + day;
	            }
	        }
	        //get user's most used languages
	        for (var key in UserLanguages) {
	            languages += "language=" + UserLanguages[key] + "+";
	        }
	        var link = "https://api.github.com/search/repositories?q=created:>" + pastDate + "+" + languages + "&sort=star&order=desc";
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    NewsFeedService.prototype.extractData = function (res) {
	        if (res.status < 200 || res.status >= 300) {
	            throw new Error('Bad response status: ' + res.status);
	        }
	        var body = res.json();
	        // console.log(body);
	        return body || {};
	    };
	    NewsFeedService.prototype.handleError = function (error) {
	        var errMsg = error.message || 'Server Error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    NewsFeedService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], NewsFeedService);
	    return NewsFeedService;
	}());
	exports.NewsFeedService = NewsFeedService;
	//# sourceMappingURL=news-feed.service.js.map

/***/ },

/***/ 337:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	//Http client
	// import {Http, Response} from '@angular/http';
	// import {Language} from '../language';
	var UserDataService = (function () {
	    function UserDataService() {
	    }
	    //return an array of languages used in repo
	    UserDataService.prototype.getLanguageArray = function (data) {
	        var langArr = [];
	        for (var i = 0; i < data.length; i++) {
	            langArr.push(data[i].language);
	        }
	        return langArr;
	    };
	    //get unique language used in an array
	    UserDataService.prototype.getUniqueLanguages = function (langArr) {
	        var a = [];
	        var prev;
	        langArr.sort();
	        for (var i = 0; i < langArr.length; i++) {
	            if (langArr[i] !== prev) {
	                a.push(langArr[i]);
	            }
	            prev = langArr[i];
	        }
	        return a;
	    };
	    //get Maximun used langugae in the form [language:use]
	    //returns the max used languages in the following object format
	    // 	[language : number of usage]
	    UserDataService.prototype.getMax = function (arr) {
	        var a = [];
	        var b = [];
	        var prev;
	        var array2 = [];
	        arr.sort();
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i] !== prev) {
	                a.push(arr[i]);
	                b.push(1);
	            }
	            else {
	                b[b.length - 1]++;
	            }
	            prev = arr[i];
	        }
	        for (var i = 0; i < a.length; i++) {
	            for (var j = 0; j < a.length; j++) {
	                if (b[i] > b[j]) {
	                    var temp = b[i];
	                    b[i] = b[j];
	                    b[j] = temp;
	                    temp = a[i];
	                    a[i] = a[j];
	                    a[j] = temp;
	                }
	            }
	        }
	        prev = b[0];
	        array2[a[0]] = b[0];
	        for (var i = 1; i < a.length; i++) {
	            if (b[i] === prev) {
	                array2[a[i]] = b[i];
	            }
	        }
	        return array2;
	    };
	    UserDataService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], UserDataService);
	    return UserDataService;
	}());
	exports.UserDataService = UserDataService;
	//# sourceMappingURL=user-data.service.js.map

/***/ },

/***/ 338:
/***/ function(module, exports) {

	"use strict";
	var NewsFeed = (function () {
	    function NewsFeed() {
	    }
	    return NewsFeed;
	}());
	exports.NewsFeed = NewsFeed;


/***/ },

/***/ 339:
/***/ function(module, exports) {

	module.exports = "<h3 style=\"text-align:center\">News Feed</h3>\r\n<h5 style=\"text-align:center\">Your daily feed from <em>GitHub</em></h5>\r\n<div *ngIf=\"newsFeed\">\r\n\r\n  <div class=\"demo-card-square mdl-card mdl-shadow--4dp\" style=\"position: relative;\r\n    width: 50%;\r\n    margin-left: 25%;margin-bottom: 3%;\" *ngFor=\"let news of newsFeed\">\r\n    <div class=\"mdl-card__title mdl-card--expand\" style=\"background-color: #2196F3;\">\r\n      <h2 class=\"mdl-card__title-text\">{{news.name}}</h2>\r\n    </div>\r\n    <div class=\"mdl-card__supporting-text\">\r\n    {{news.description}}\r\n    </div>\r\n    <br>\r\n    <div class=\"mdl-card--border\">\r\n      <i class=\"material-icons\">star</i><span id=\"star\">{{news.stars}}</span>\r\n      <i class=\"material-icons\">device_hub</i> <span>{{news.forks}}</span>\r\n    </div>\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n      <strong>\r\n      {{news.language}}</strong>\r\n  <button  class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" (click)=\"goToGithub(news.html_url)\">\r\n  <small>View On Github</small>\r\n</button>\r\n    </div>\r\n  </div>\r\n  <br><br>\r\n</div>\r\n";

/***/ },

/***/ 340:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var favourite_service_1 = __webpack_require__(341);
	var user_data_service_1 = __webpack_require__(337);
	var FavouriteComponent = (function () {
	    function FavouriteComponent(favouriteService, userDataService) {
	        this.favouriteService = favouriteService;
	        this.userDataService = userDataService;
	        this.hasReceivedData = false;
	        this.languageArray = [];
	        this.uniqueLanguage = [];
	        this.nameArray = [];
	        this.numArray = [];
	        this.maxLang = [];
	        this.maxUse = [];
	    }
	    FavouriteComponent.prototype.ngOnInit = function () {
	        this.getFavouriteData();
	        this.getRecentData();
	    };
	    FavouriteComponent.prototype.ngDoCheck = function () {
	        if (this.response && !this.hasReceivedData && this.recent) {
	            var data = this.response;
	            this.languageArray = this.userDataService.getLanguageArray(data);
	            this.uniqueLanguage = this.userDataService.getUniqueLanguages(this.languageArray).reverse();
	            // this.language_use=this.getLanguageUse(this.languageArray,this.uniqueLanguage);
	            this.nameArray = this.getLanguageUse(this.languageArray, this.uniqueLanguage);
	            this.numArray = this.getLanguageNumber(this.languageArray, this.uniqueLanguage);
	            this.unWrap(this.userDataService.getMax(this.languageArray));
	            this.getRecentlyUpdated(this.recent);
	            this.hasReceivedData = true;
	        }
	    };
	    //unwrap the language:used max array2
	    FavouriteComponent.prototype.unWrap = function (data) {
	        //get key
	        for (var key in data) {
	            this.maxLang.push(key);
	            this.maxUse.push(data[key]);
	        }
	    };
	    FavouriteComponent.prototype.getFavouriteData = function () {
	        var _this = this;
	        return this.favouriteService.getData()
	            .subscribe(function (response) { return _this.response = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    //get the name of language
	    FavouriteComponent.prototype.getLanguageUse = function (langArr, unique) {
	        var nameArr = [];
	        unique.map(function (currentValue, index, array) {
	            var check = currentValue;
	            var counter = 0;
	            for (var i = 0; i < langArr.length; i++) {
	                if (check == langArr[i]) {
	                    counter++;
	                }
	            }
	            if (check != null) {
	                nameArr.push(check);
	            }
	        });
	        return nameArr;
	    };
	    //get the number of repo in particular lang
	    FavouriteComponent.prototype.getLanguageNumber = function (langArr, unique) {
	        var numArr = [];
	        unique.map(function (currentValue, index, array) {
	            var check = currentValue;
	            var counter = 0;
	            for (var i = 0; i < langArr.length; i++) {
	                if (check == langArr[i]) {
	                    counter++;
	                }
	            }
	            if (check != null) {
	                numArr.push(counter);
	            }
	        });
	        return numArr;
	    };
	    //get recently updated data
	    FavouriteComponent.prototype.getRecentData = function () {
	        var _this = this;
	        return this.favouriteService.getRecentUpdated()
	            .subscribe(function (recent) { return _this.recent = recent; }, function (error) { return _this.errorMessage = error; });
	    };
	    //unwrap the json data
	    FavouriteComponent.prototype.getRecentlyUpdated = function (data) {
	        var newData = data.items;
	        newData = newData[0];
	        this.recentName = newData.name;
	        this.recentUrl = newData.html_url;
	        this.recentLang = newData.language;
	    };
	    //navigate
	    FavouriteComponent.prototype.getRecentUrl = function () {
	        window.location.assign(this.recentUrl);
	    };
	    FavouriteComponent = __decorate([
	        core_1.Component({
	            selector: 'user-favourite',
	            template: __webpack_require__(342),
	            directives: [],
	            providers: [favourite_service_1.FavouriteService, user_data_service_1.UserDataService]
	        }), 
	        __metadata('design:paramtypes', [favourite_service_1.FavouriteService, user_data_service_1.UserDataService])
	    ], FavouriteComponent);
	    return FavouriteComponent;
	}());
	exports.FavouriteComponent = FavouriteComponent;
	//# sourceMappingURL=favourite.component.js.map

/***/ },

/***/ 341:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	//Http client
	var http_1 = __webpack_require__(316);
	//Observable
	var Observable_1 = __webpack_require__(41);
	var FavouriteService = (function () {
	    function FavouriteService(http) {
	        this.http = http;
	        this.username = sessionStorage.getItem('username');
	        var link = "https://api.github.com/users/" + this.username + "/repos"; //github api
	        this.apiUrl = link;
	    }
	    //get user info
	    FavouriteService.prototype.getData = function () {
	        return this.http.get(this.apiUrl)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    //get recently updated repo
	    FavouriteService.prototype.getRecentUpdated = function () {
	        var link = "https://api.github.com/search/repositories?q=user:" + this.username + "&sort=updated";
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    FavouriteService.prototype.extractData = function (res) {
	        if (res.status < 200 || res.status >= 300) {
	            throw new Error('Bad response status: ' + res.status);
	        }
	        var body = res.json();
	        return body || {};
	    };
	    FavouriteService.prototype.handleError = function (error) {
	        var errMsg = error.message || 'Server Error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    FavouriteService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], FavouriteService);
	    return FavouriteService;
	}());
	exports.FavouriteService = FavouriteService;
	//# sourceMappingURL=favourite.service.js.map

/***/ },

/***/ 342:
/***/ function(module, exports) {

	module.exports = "<!-- <h3 style=\"text-align:center\">My Favourites<h3> -->\r\n<div class=\"mdl-grid\">\r\n\r\n    <!-- first column -->\r\n    <div class=\"mdl-cell mdl-cell--3-col\">\r\n        <table class=\"mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp\">\r\n            <thead>\r\n                <tr>\r\n                    <th>Language</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody *ngIf=\"languageArray\">\r\n                <tr *ngFor=\"let info of nameArray\">\r\n                    <td>{{info}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <!-- second column -->\r\n        <h5>Mostly Used languages:</h5>\r\n        <ul class=\"demo-list-item mdl-list\" *ngIf=\"languageArray\">\r\n            <li class=\"mdl-list__item\" *ngFor=\"let lang of maxLang\">\r\n                <strong class=\"mdl-list__item-primary-content\">\r\n            <i class=\"material-icons\">beenhere</i>  {{lang}}\r\n            </strong>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n\r\n    <!-- third column -->\r\n    <div class=\"mdl-cell mdl-cell--3-col\">\r\n        <table class=\"mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp\">\r\n            <thead>\r\n                <tr>\r\n                    <th>Number of Repository</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody *ngIf=\"languageArray\">\r\n                <tr *ngFor=\"let info of numArray\">\r\n                    <td>{{info}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n\r\n    <div class=\"mdl-cell mdl-cell--3-col\">\r\n\r\n        <div class=\"demo-card-square mdl-card mdl-shadow--2dp\">\r\n            <div class=\"mdl-card__title mdl-card--expand\">\r\n                <h2 class=\"mdl-card__title-text\">Recently Updated </h2>\r\n            </div>\r\n            <div class=\"mdl-card__supporting-text\">\r\n                You have recently updated the repository : <strong>{{recentName}}</strong> <br> <br>\r\n                Language: <strong>{{recentLang}}</strong>\r\n            </div>\r\n            <div class=\"mdl-card__actions mdl-card--border\">\r\n                <a (click)=\"getRecentUrl()\" class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\">\r\n                    View On Github\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n";

/***/ },

/***/ 343:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var top_trending_service_1 = __webpack_require__(344);
	var Trending_1 = __webpack_require__(345);
	var TopTrendingComponent = (function () {
	    function TopTrendingComponent(topTrendingService) {
	        this.topTrendingService = topTrendingService;
	        this.hasDumped = false;
	        this.trending = [];
	    }
	    TopTrendingComponent.prototype.ngOnInit = function () {
	        this.maxUsedLang = sessionStorage.getItem('maxLang');
	        this.apiUrl = "https://api.github.com/search/repositories?q=language:" + this.maxUsedLang + "&sort=fork&order=desc";
	        this.getTrendingData(this.apiUrl);
	    };
	    TopTrendingComponent.prototype.ngDoCheck = function () {
	        if (!this.hasDumped && this.response) {
	            var data = this.response;
	            this.trending = this.unpackData(data.items);
	            this.hasDumped = true;
	        }
	    };
	    TopTrendingComponent.prototype.goToGithub = function (link) {
	        window.location.assign(link);
	    };
	    TopTrendingComponent.prototype.getTrendingData = function (link) {
	        var _this = this;
	        this.topTrendingService.getTrending(link)
	            .subscribe(function (response) { return _this.response = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    TopTrendingComponent.prototype.unpackData = function (data) {
	        var resArray = [];
	        for (var i = 0; i < data.length; i++) {
	            var box = data[i];
	            var myInfo = new Trending_1.Trending();
	            myInfo.name = box.full_name;
	            myInfo.html_url = box.html_url;
	            myInfo.language = box.language;
	            myInfo.description = box.description;
	            myInfo.fork = box.forks;
	            resArray.push(myInfo);
	        }
	        return resArray;
	    };
	    TopTrendingComponent = __decorate([
	        core_1.Component({
	            selector: 'top-trending',
	            template: __webpack_require__(346),
	            providers: [top_trending_service_1.TopTrendingService]
	        }), 
	        __metadata('design:paramtypes', [top_trending_service_1.TopTrendingService])
	    ], TopTrendingComponent);
	    return TopTrendingComponent;
	}());
	exports.TopTrendingComponent = TopTrendingComponent;
	//# sourceMappingURL=top-trending.component.js.map

/***/ },

/***/ 344:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var http_1 = __webpack_require__(316);
	var Observable_1 = __webpack_require__(41);
	var TopTrendingService = (function () {
	    function TopTrendingService(http) {
	        this.http = http;
	    }
	    TopTrendingService.prototype.getTrending = function (link) {
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    TopTrendingService.prototype.extractData = function (res) {
	        if (res.status < 200 || res.status >= 300) {
	            throw new Error('Bad response status: ' + res.status);
	        }
	        var body = res.json();
	        return body || {};
	    };
	    TopTrendingService.prototype.handleError = function (error) {
	        var errMsg = error.message || 'Server Error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    TopTrendingService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], TopTrendingService);
	    return TopTrendingService;
	}());
	exports.TopTrendingService = TopTrendingService;
	//# sourceMappingURL=top-trending.service.js.map

/***/ },

/***/ 345:
/***/ function(module, exports) {

	"use strict";
	var Trending = (function () {
	    function Trending() {
	    }
	    return Trending;
	}());
	exports.Trending = Trending;
	//# sourceMappingURL=Trending.js.map

/***/ },

/***/ 346:
/***/ function(module, exports) {

	module.exports = "<h3 style=\"text-align:center\">Trending</h3>\r\n\r\n<h5 style=\"text-align:center\">Top Trending repositories on the basis of your <strong>most favourite language</strong></h5>\r\n\r\n<div *ngIf=\"trending\">\r\n\r\n  <div class=\"demo-card-square mdl-card mdl-shadow--4dp\" style=\"position: relative;\r\n    width: 50%;\r\n    margin-left: 25%;margin-bottom: 3%;\" *ngFor=\"let trend of trending\">\r\n    <div class=\"mdl-card__title mdl-card--expand\" style=\"background-color: #8BC34A;\" >\r\n      <h2 class=\"mdl-card__title-text\">{{trend.name}}</h2>\r\n    </div>\r\n    <div class=\"mdl-card__supporting-text\">\r\n    {{trend.description}}\r\n    </div>\r\n    <br>\r\n    <div class=\"mdl-card--border\">\r\n      <i class=\"material-icons\">device_hub</i> <span>{{trend.fork}}</span>\r\n    </div>\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n      <strong>\r\n      {{trend.language}}</strong>\r\n  <button  class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" (click)=\"goToGithub(trend.html_url)\">\r\n  <small>View On Github</small>\r\n</button>\r\n    </div>\r\n  </div>\r\n  <br><br>\r\n</div>\r\n";

/***/ },

/***/ 347:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var latest_service_1 = __webpack_require__(348);
	var Issue = (function () {
	    function Issue() {
	    }
	    return Issue;
	}());
	var LatestComponent = (function () {
	    function LatestComponent(latestService) {
	        this.latestService = latestService;
	        this.hasDumped = false;
	        this.latestIssue = [];
	    }
	    LatestComponent.prototype.ngOnInit = function () {
	        this.getIssue();
	    };
	    LatestComponent.prototype.ngDoCheck = function () {
	        if (this.response && !this.hasDumped) {
	            this.latestIssue = this.unpackData(this.response);
	            console.log(this.latestIssue);
	            this.hasDumped = true;
	        }
	    };
	    LatestComponent.prototype.getIssue = function () {
	        var _this = this;
	        this.latestService.getLatestIssue()
	            .subscribe(function (response) { return _this.response = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    LatestComponent.prototype.unpackData = function (data) {
	        var info = data.items;
	        var resArray = [];
	        for (var i = 0; i < info.length; i++) {
	            var box = info[i];
	            var obj = new Issue();
	            obj.title = box.title;
	            obj.body = box.body;
	            obj.html_url = box.html_url;
	            obj.comments = box.comments;
	            obj.created_at = box.created_at;
	            obj.state = box.state;
	            resArray.push(obj);
	        }
	        return resArray;
	    };
	    LatestComponent = __decorate([
	        core_1.Component({
	            selector: 'latest-weekly',
	            template: __webpack_require__(349),
	            providers: [latest_service_1.LatestService]
	        }), 
	        __metadata('design:paramtypes', [latest_service_1.LatestService])
	    ], LatestComponent);
	    return LatestComponent;
	}());
	exports.LatestComponent = LatestComponent;
	//# sourceMappingURL=latest.component.js.map

/***/ },

/***/ 348:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var http_1 = __webpack_require__(316);
	var Observable_1 = __webpack_require__(41);
	var LatestService = (function () {
	    function LatestService(http) {
	        this.http = http;
	    }
	    LatestService.prototype.getLatestIssue = function () {
	        var link = "https://api.github.com/search/issues?q=state:open&sort=created&order=desc";
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    LatestService.prototype.extractData = function (res) {
	        if (res.status < 200 || res.status >= 300) {
	            throw new Error('Bad response status: ' + res.status);
	        }
	        var body = res.json();
	        return body || {};
	    };
	    LatestService.prototype.handleError = function (error) {
	        var errMsg = error.message || 'Server Error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    LatestService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], LatestService);
	    return LatestService;
	}());
	exports.LatestService = LatestService;
	//# sourceMappingURL=latest.service.js.map

/***/ },

/***/ 349:
/***/ function(module, exports) {

	module.exports = "<h3 style=\"text-align:center\">Latest issues</h3>\r\n\r\n<h5 style=\"text-align:center\">Get the <strong>issues</strong> that are <strong>opened</strong> most recently </h5>\r\n\r\n<div *ngIf=\"latestIssue\">\r\n\r\n  <div class=\"demo-card-square mdl-card mdl-shadow--4dp\" style=\"position: relative;\r\n    width: 50%;\r\n    margin-left: 25%;margin-bottom: 3%;\" *ngFor=\"let issue of latestIssue\">\r\n    <div class=\"mdl-card__title mdl-card--expand\" style=\"    background-color: rgba(244, 67, 54, 0.9);\" >\r\n      <h2 class=\"mdl-card__title-text\">{{issue.title}}</h2>\r\n    </div>\r\n    <div class=\"mdl-card__supporting-text\">\r\n    {{issue.body}}\r\n    </div>\r\n    <br>\r\n    <div class=\"mdl-card--border\">\r\n      <i class=\"material-icons\">comment</i> <span>{{issue.comments}}</span>\r\n    </div>\r\n    <div class=\"mdl-card--border\">\r\n      <i class=\"material-icons\">access_time</i><span>{{issue.created_at}}</span>\r\n    </div>\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n      <strong>State: </strong> {{issue.state}}\r\n  <a href=\"{{issue.html_url}}\" class=\"mdl-button mdl-js-button mdl-button--primary\">\r\n  <small>View On Github</small>\r\n</a>\r\n    </div>\r\n  </div>\r\n  <br><br>\r\n</div>\r\n";

/***/ },

/***/ 350:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var CreditComponent = (function () {
	    function CreditComponent() {
	    }
	    CreditComponent = __decorate([
	        core_1.Component({
	            selector: 'credit-component',
	            template: __webpack_require__(351)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CreditComponent);
	    return CreditComponent;
	}());
	exports.CreditComponent = CreditComponent;
	//# sourceMappingURL=credit.component.js.map

/***/ },

/***/ 351:
/***/ function(module, exports) {

	module.exports = "<h3 style=\"text-align:center\">Credits</h3>\r\n\r\n\r\n  <div class=\"demo-card-square mdl-card mdl-shadow--4dp\" style=\"position: relative;\r\n    width: 50%;\r\n    margin-left: 25%;margin-bottom: 3%;\">\r\n    <div class=\"mdl-card__title mdl-card--expand\" style=\"background-color: #2196F3;\">\r\n      <h4>Github Bucket</h4>\r\n    </div>\r\n    <div class=\"mdl-card__supporting-text\">\r\n\r\n        <h4><i class=\"material-icons\" style=\"float:right\">check_box</i> <a href=\"https://angular.io/\">Angular 2</a></h4>\r\n        <h4><i class=\"material-icons\" style=\"float:right\">check_box</i> <a href=\"https://getmdl.io/started/\">Material Lite</a></h4>\r\n        <h4><i class=\"material-icons\" style=\"float:right\">check_box</i> <a href=\"https://design.google.com/icons/\">Material icons</a></h4>\r\n        <h4><i class=\"material-icons\" style=\"float:right\">check_box</i> <a href=\"https://developer.github.com/v3/\">Github API</a></h4>\r\n        <h4><i class=\"material-icons\" style=\"float:right\">check_box</i> <a href=\"https://www.firebase.com/\">Firebase</a></h4>\r\n    </div>\r\n    <br>\r\n    <div class=\"mdl-card--border\">\r\n    </div>\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n\r\n  <small style=\"text-align:center\">\r\n    All trademarks and logo mentioning \"Github\" belongs to <a href=\"https://github.com/\">Github</a>\r\n    <br>\r\n    Developed by <a href=\"https://github.com/abrarShariar\">Abrar </a>and <a href=\"https://github.com/SiamRafsunjani\">Siam</a>\r\n    as part of <a href=\"https://www.angularattack.com/\">Angular Attack </a> - 2016 Hackathon\r\n  </small>\r\n    </div>\r\n  </div>\r\n";

/***/ },

/***/ 352:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var profile_service_1 = __webpack_require__(353);
	var ProfileComponent = (function () {
	    function ProfileComponent(profileService) {
	        this.profileService = profileService;
	        this.hasDataDumped = false;
	    }
	    ProfileComponent.prototype.ngOnInit = function () {
	        this.username = sessionStorage.getItem('username');
	        this.apiLink = "https://api.github.com/users/" + this.username;
	        this.getUserInfo(this.apiLink);
	    };
	    ProfileComponent.prototype.ngDoCheck = function () {
	        if (this.response && !this.hasDataDumped) {
	            var data = this.response;
	            this.avatar_url = data.avatar_url;
	            this.blog_url = "https://" + data.blog;
	            this.created = data.created;
	            this.email = data.email;
	            this.followers = data.followers;
	            this.following = data.following;
	            this.hireable = data.hireable;
	            this.html_url = data.html_url;
	            this.location = data.location;
	            this.full_name = data.full_name;
	            this.public_gists = data.public_gists;
	            this.public_repo = data.public_repos;
	            this.type = data.type;
	            this.updated_at = data.updated_at;
	            this.hasDataDumped = true;
	        }
	    };
	    ProfileComponent.prototype.getUserInfo = function (link) {
	        var _this = this;
	        this.profileService.getProfileInfo(link)
	            .subscribe(function (response) { return _this.response = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    ProfileComponent.prototype.goToGithub = function (link) {
	        window.location.assign(link);
	    };
	    ProfileComponent.prototype.goToBlog = function (link) {
	        window.location.assign(link);
	    };
	    ProfileComponent = __decorate([
	        core_1.Component({
	            selector: 'user-profile',
	            template: __webpack_require__(354),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [profile_service_1.ProfileService])
	    ], ProfileComponent);
	    return ProfileComponent;
	}());
	exports.ProfileComponent = ProfileComponent;
	//# sourceMappingURL=profile.component.js.map

/***/ },

/***/ 353:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	//Http client
	var http_1 = __webpack_require__(316);
	//Observable
	var Observable_1 = __webpack_require__(41);
	var ProfileService = (function () {
	    function ProfileService(http) {
	        this.http = http;
	    }
	    //get user info from api
	    ProfileService.prototype.getProfileInfo = function (link) {
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    ProfileService.prototype.extractData = function (res) {
	        if (res.status < 200 || res.status >= 300) {
	            throw new Error('Bad response status: ' + res.status);
	        }
	        var body = res.json();
	        return body || {};
	    };
	    ProfileService.prototype.handleError = function (error) {
	        var errMsg = error.message || 'Server Error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    ProfileService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], ProfileService);
	    return ProfileService;
	}());
	exports.ProfileService = ProfileService;
	//# sourceMappingURL=profile.service.js.map

/***/ },

/***/ 354:
/***/ function(module, exports) {

	module.exports = "<h3 style=\"text-align:center\">{{username}}'s Bucket</h3>\r\n\r\n<div class=\"demo-card-wide mdl-card mdl-shadow--2dp\" style=\"position: relative;\r\n  width: 50%;\r\n  margin-left: 25%;margin-bottom: 3%;\">\r\n  <div class=\"mdl-card__title\" style=\"background:url('{{avatar_url}}') bottom right 15% no-repeat;background-size: contain;\">\r\n    <h2 class=\"mdl-card__title-text\">{{full_name}}</h2>\r\n  </div>\r\n  <div class=\"mdl-card__supporting-text\">\r\n    <p>\r\n      <strong>Email: </strong> {{email}}\r\n    </p>\r\n\r\n    <p>\r\n      <strong>Github: </strong><a (click)=\"goToGithub(html_url)\">{{html_url}}</a>\r\n    </p>\r\n    <p>\r\n      <strong>Web: </strong><a (click)=\"goToBlog(blog_url)\">{{blog_url}}</a>\r\n    </p>\r\n    <p>\r\n      <strong>Type: </strong>{{type}}\r\n    </p>\r\n    <p>\r\n      <strong>Public Repo: </strong>{{public_repo}}\r\n    </p>\r\n    <p>\r\n      <strong>Public Gists: </strong>{{public_gists}}\r\n    </p>\r\n\r\n    <p>\r\n      <strong>Location: </strong>{{location}}\r\n    </p>\r\n    <p>\r\n      <strong>Followers: </strong>{{followers}}\r\n    </p>\r\n    <p>\r\n      <strong>Following: </strong>{{following}}\r\n    </p>\r\n\r\n\r\n\r\n    <p>\r\n      <strong>Hireable: </strong>\r\n      <i class=\"material-icons\" *ngIf=\"hireable\">check_circle</i>\r\n      <i class=\"material-icons\" *ngIf=\"!hireable\">highlight_off</i>\r\n    </p>\r\n\r\n\r\n  </div>\r\n  <div class=\"mdl-card__actions mdl-card--border\">\r\n    <a class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\">\r\n\r\n    </a>\r\n  </div>\r\n  <div class=\"mdl-card__menu\">\r\n    <button (click)=\"goToGithub(html_url)\" class=\"mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect\">\r\n      <i class=\"material-icons\">build</i>\r\n    </button>\r\n  </div>\r\n</div>\r\n";

/***/ },

/***/ 355:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	var popular_service_1 = __webpack_require__(356);
	var PopularUser = (function () {
	    function PopularUser() {
	    }
	    return PopularUser;
	}());
	var PopularRepo = (function () {
	    function PopularRepo() {
	    }
	    return PopularRepo;
	}());
	var PopularComponent = (function () {
	    function PopularComponent(popularService) {
	        this.popularService = popularService;
	        this.dataDump = false;
	    }
	    PopularComponent.prototype.ngOnInit = function () {
	        this.getPopularUser();
	        this.getPopularRepo();
	    };
	    //get popular users on the basis of followers
	    PopularComponent.prototype.getPopularUser = function () {
	        var _this = this;
	        this.popularService.getPopularUser()
	            .subscribe(function (response) { return _this.userData = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    //get popular repo on the basis of forks
	    PopularComponent.prototype.getPopularRepo = function () {
	        var _this = this;
	        this.popularService.getPopularRepo()
	            .subscribe(function (response) { return _this.repoData = response; }, function (error) { return _this.errorMessage = error; });
	    };
	    PopularComponent.prototype.ngDoCheck = function () {
	        if (this.userData && !this.dataDump && this.repoData) {
	            this.popularUser = this.unpackUserData(this.userData);
	            this.popularRepo = this.unpackRepoData(this.repoData);
	            this.dataDump = true;
	        }
	    };
	    PopularComponent.prototype.unpackRepoData = function (data) {
	        var resArray = [];
	        var info = data.items;
	        for (var i = 0; i < info.length; i++) {
	            var repo = new PopularRepo();
	            var obj = info[i];
	            repo.full_name = obj.full_name;
	            repo.html_url = obj.html_url;
	            repo.forks = obj.forks;
	            repo.language = obj.language;
	            repo.stargazers_count = obj.stargazers_count;
	            repo.watchers = obj.watchers;
	            resArray.push(repo);
	        }
	        return resArray;
	    };
	    PopularComponent.prototype.unpackUserData = function (data) {
	        var resArray = [];
	        var info = data.items;
	        for (var i = 0; i < info.length; i++) {
	            var user = new PopularUser();
	            var obj = info[i];
	            user.login = obj.login;
	            user.avatar_url = obj.avatar_url;
	            user.html_url = obj.html_url;
	            resArray.push(user);
	        }
	        return resArray;
	    };
	    PopularComponent = __decorate([
	        core_1.Component({
	            selector: 'most-populer',
	            template: __webpack_require__(357),
	            providers: [popular_service_1.PopularService]
	        }), 
	        __metadata('design:paramtypes', [popular_service_1.PopularService])
	    ], PopularComponent);
	    return PopularComponent;
	}());
	exports.PopularComponent = PopularComponent;
	//# sourceMappingURL=popular.component.js.map

/***/ },

/***/ 356:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	//Http client
	var http_1 = __webpack_require__(316);
	//Observable
	var Observable_1 = __webpack_require__(41);
	var PopularService = (function () {
	    function PopularService(http) {
	        this.http = http;
	    }
	    PopularService.prototype.getPopularUser = function () {
	        var link = "https://api.github.com/search/users?q=followers:>1000";
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    PopularService.prototype.getPopularRepo = function () {
	        var link = "https://api.github.com/search/repositories?q=forks:>1000";
	        return this.http.get(link)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    PopularService.prototype.extractData = function (res) {
	        if (res.status < 200 || res.status >= 300) {
	            throw new Error('Bad response status: ' + res.status);
	        }
	        var body = res.json();
	        return body || {};
	    };
	    PopularService.prototype.handleError = function (error) {
	        var errMsg = error.message || 'Server Error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    PopularService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], PopularService);
	    return PopularService;
	}());
	exports.PopularService = PopularService;
	//# sourceMappingURL=popular.service.js.map

/***/ },

/***/ 357:
/***/ function(module, exports) {

	module.exports = "\r\n<div class=\"mdl-grid\">\r\n    <div class=\"mdl-cell mdl-cell--6-col\">\r\n        <h5>Popular Users</h5>\r\n        <div *ngIf=\"userData\">\r\n            <div class=\"demo-card-wide mdl-card mdl-shadow--3dp\" *ngFor=\"let user of popularUser\" style=\"margin-bottom: 5%\">\r\n              <img src=\"{{user.avatar_url}}\"/>\r\n                <div class=\"mdl-card__title\">\r\n                    <h2 class=\"mdl-card__title-text\">{{user.login}}</h2>\r\n                </div>\r\n\r\n                <div class=\"mdl-card__supporting-text\">\r\n                </div>\r\n                <div class=\"mdl-card__actions mdl-card--border\">\r\n                    <a href=\"{{user.html_url}}\" class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\">\r\n                    Github Profile\r\n                  </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"mdl-cell mdl-cell--6-col\">\r\n        <h5>Popular Repositories</h5>\r\n        <div *ngIf=\"repoData\">\r\n            <div class=\"demo-card-wide mdl-card mdl-shadow--2dp\" *ngFor=\"let repo of popularRepo\" style=\"margin-bottom: 5%;\">\r\n                <div class=\"mdl-card__title\">\r\n                    <h2 class=\"mdl-card__title-text\">{{repo.full_name}}</h2>\r\n                </div>\r\n                <div class=\"mdl-card__supporting-text\">\r\n                    <p>\r\n                        <i class=\"material-icons\">device_hub</i> {{repo.forks}}\r\n                    </p>\r\n                    <p>\r\n                        <strong><i class=\"material-icons\">visibility</i></strong> {{repo.watchers}}\r\n                    </p>\r\n                    <p>\r\n                      <i class=\"material-icons\">star</i> {{repo.stargazers_count}}\r\n                    </p>\r\n                </div>\r\n                <div class=\"mdl-card__actions mdl-card--border\">\r\n                    <a href=\"{{repo.html_url}}\" class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\">\r\n                  View On Github\r\n                </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n";

/***/ },

/***/ 358:
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-layout mdl-js-layout mdl-layout--fixed-drawer\r\n            mdl-layout--fixed-header\">\r\n    <header class=\"mdl-layout__header\">\r\n        <div class=\"mdl-layout__header-row\">\r\n            <div class=\"mdl-layout-spacer\">\r\n            </div>\r\n            <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--expandable\r\n                  mdl-textfield--floating-label mdl-textfield--align-right\">\r\n            </div>\r\n            <button id=\"profile\" (click)=\"goToProfile()\" class=\"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent\">\r\n                <i class=\"material-icons\">person</i>\r\n            </button>\r\n            <div class=\"mdl-tooltip\" for=\"profile\">\r\n                Profile\r\n            </div>\r\n            <button (click)=\"logout()\" id=\"logout\" style=\"margin-left: 1%\" class=\"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent\">\r\n                Logout\r\n            </button>\r\n            <div class=\"mdl-tooltip\" for=\"logout\">\r\n                Logout\r\n            </div>\r\n        </div>\r\n\r\n    </header>\r\n    <div class=\"mdl-layout__drawer\">\r\n        <span class=\"mdl-layout-title\">Github Bucket</span>\r\n        <nav class=\"mdl-navigation\">\r\n            <a class=\"mdl-navigation__link\" (click)=\"goToNewsFeed()\"><i class=\"material-icons\" style=\"float:right\">free_breakfast</i>News Feed</a>\r\n            <a class=\"mdl-navigation__link\" (click)=\"goToFavourite()\"><i class=\"material-icons\" style=\"float:right\">favorite</i>Favourite</a>\r\n            <a class=\"mdl-navigation__link\" (click)=\"goToTrending()\"><i class=\"material-icons\" style=\"float:right\">trending_up</i>Top Trending</a>\r\n            <a class=\"mdl-navigation__link\" (click)=\"goToPopular()\"><i class=\"material-icons\" style=\"float: right;\">whatshot</i>Most Popular</a>\r\n            <a class=\"mdl-navigation__link\" (click)=\"goToLatest()\"><i class=\"material-icons\" style=\"float:right\">flash_on</i>Latest issues</a>\r\n            <a class=\"mdl-navigation__link\" (click)=\"goToCredits()\">Credits</a>\r\n        </nav>\r\n        <br><br><br>\r\n    </div>\r\n\r\n\r\n    <main class=\"mdl-layout__content\">\r\n       <div class=\"page-content\">\r\n         <router-outlet></router-outlet>\r\n       </div>\r\n     </main>\r\n</div>\r\n";

/***/ },

/***/ 359:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 363:
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-layout mdl-js-layout\" *ngIf=\"!isDashboard\">\r\n    <div style=\"text-align: -webkit-center;\">\r\n        <h1>{{appTitle}}</h1>\r\n        <h3 *ngIf=\"isSessionSet\">Welcome to <span style=\"color: rgba(156, 39, 176, 0.81)\">Github Bucket</span><br> Explore and have fun !!</h3>\r\n        <h5>\r\n            Github Bucket brings all the stuffs you love about <a href=\"https://github.com/\">Github</a> in one <em>Bucket</em>\r\n        </h5>\r\n        <!-- Accent-colored raised button with ripple -->\r\n        <div *ngIf=\"isSessionSet\">\r\n            <a (click)=\"goToDashboard()\" class=\"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--primary\">\r\n            {{ButtonText}}\r\n          </a>\r\n        </div>\r\n        <div *ngIf=\"!isSessionSet\">\r\n            <button class=\"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent\" onclick=\"connectWithGithub()\">\r\n                {{ButtonText}}\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<router-outlet></router-outlet>\r\n";

/***/ }

});


/** WEBPACK FOOTER **
 ** app.335d748a3b0816830320.js
 **/